import { jsx as y } from "react/jsx-runtime";
import { useEffect as g } from "react";
import n from "./import.js";
function w(a, i) {
  const l = i.chatUnityID, p = i.chatBlackID, d = i.chatEliteID, o = ["Black", "Golden", "Sensei"].includes(((a == null ? void 0 : a.belt) || "").split(" ")[0]);
  return (a == null ? void 0 : a.tag) === "unity" ? l : o || a != null && a.isClubeBlack ? p : d;
}
const B = ({
  accountsJwt: a,
  currentUser: i,
  hyperflowConfig: l,
  hyperflowJwt: p
}) => {
  const d = n("https://webchat.hyperflow.global/sdk.js"), m = w(i, l);
  return g(() => {
    try {
      if (Hyperflow.reinit(m, { sender: p }).on("getStarted", async () => {
        var o;
        try {
          const h = await a(), t = {
            id: i.id,
            name: i.name.split(" ")[0],
            email: i.email,
            sender: h,
            origin: l.origin
          };
          i != null && i.isAccessPolicy && (t.original_id = i == null ? void 0 : i.originalUserId, t.original_name = (o = i == null ? void 0 : i.originalUserName) == null ? void 0 : o.split(" ")[0], t.original_email = i == null ? void 0 : i.originalUserEmail);
          const f = JSON.parse(JSON.stringify(t));
          Hyperflow.initFlow(l.flowId, f);
        } catch (h) {
          console.error("Error getting JWT: ", h);
        }
      }), typeof Hyperflow > "u")
        return;
    } catch (o) {
      console.error("Error initializing Hyperflow: ", o);
    }
  }, [d, i == null ? void 0 : i.id]), /* @__PURE__ */ y("div", { id: "hyperflow-chat-container" });
};
export {
  B as default
};
//# sourceMappingURL=chat.js.map
